import { z } from "zod";

export const ScanAttachmentWithAIInputSchema = z.object({
    fileId: z.string().nullish(),
    requestTypeId: z.number().nullish(),
    userName: z.string().nullish(),
});

export type ScanAttachmentWithAIInput = z.infer<typeof ScanAttachmentWithAIInputSchema>;